import { useForm } from 'react-hook-form'; // バリデーションライブラリ
import { validationSchema } from '../../../../utils/validationUtils'; // バリデーション定義ファイル
import { menu } from '../../../../constants';
import sty from '../../Settings/Settings.module.css';
import PropTypes from 'prop-types';
import { errorMessages } from '../../../../utils/messagesUtils';
import { ajax } from 'rxjs/ajax';
import { catchError, of } from 'rxjs';
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom';

const UpdateEmailInput = ({ email, onClick }) => {
    UpdateEmailInput.propTypes = {
        email: PropTypes.string.isRequired,
    };
    const navigate = useNavigate();

    // フォームのstateを更新
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onBlur', // フォーカスが外れたときにバリデーションを実行
    });

        // フォーム送信時の処理
    const onSubmit = (data) => {

        // request to server
        ajax({
            url: `${process.env.REACT_APP_API_BASE_URL}/settings/update-mail/send-code`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: {
                email: data.email,
            },
            withCredentials: true
        })
        .pipe(catchError(error => of(error)))
        .subscribe(
            async (fromServerResponse) => {

                if(fromServerResponse.response.message === "logout") {
                    // 現状は、メールアドレス変更はエンジニアのみ可能
                    navigate(menu.ENGINEER.SIGNIN.PATH)
                    return;
                }
                
                switch(fromServerResponse.status) {
                    case 200:
                        onClick();
                        break;

                    case 401:
                        await Swal.fire({
                            icon: 'error',
                            html: errorMessages.account_settings.invalid_mailaddress,
                            customClass: {
                                htmlContainer: 'large-text'
                            }
                        });
                        break;

                    case 404:
                        await Swal.fire({
                            icon: 'error',
                            html: errorMessages.api.not_found,
                            customClass: {
                                htmlContainer: 'large-text'
                            }
                        });
                        break;

                    default:
                        // ネットワークエラーやその他の予期しないエラー
                        await Swal.fire({ 
                            icon: 'error',
                            html: errorMessages.api.network_error,
                            customClass: {
                                htmlContainer: 'large-text'
                            }
                        });
                        break;
                }
            }
        );
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={sty['form']}>
            <div className="inner-container">
                <div className={`${sty['form__label-flex-settings']} ${sty['form__label-flex-mb']}`}>
                    <div className={sty['form__label']}>現在のメールアドレス</div>
                    <label className={sty['form__label-email']}>{email}</label>

                </div>
                <div className={`${sty['form__label-flex-settings']} ${sty['form__label-flex-mb']}`}>
                    <div className={sty['form__label']}>新しいメールアドレス</div>
                    <input type='text' {...register('email', validationSchema.email)} id="email" autoComplete="email" placeholder="taro.yamada@exmample.com" />
                    {errors.email && <p className="form__validation-msg">{errors.email.message}</p>}
                </div>
            </div>

            <div className="primary-btns">
                <button type="submit" className="primary-btn">認証コード送信</button>
            </div>
        </form>
    )
}

export default UpdateEmailInput;




